<template>
  <div class="p-[5px] ml-4 mr-4 sm:ml-2 sm:mr-2 md:ml-4 md:mr-4 lg:ml-8 lg:mr-8">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
